enum SeekerListSortType {
  ALPHABETICAL = 'ALPHABETICAL',
  CHRONOLOGICAL = 'CHRONOLOGICAL',
}

export default SeekerListSortType;
